export const ISSUE_TYPE = {
  QALITY_TEST: 'QAlity Test',
};
